export default __webpack_public_path__ + "static/topology-5d4302a7727b1fad2802ef446f1fa59b.png";